module.exports = __webpack_public_path__ + "static/media/kid25.a845aa73.png";